const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

export { native as n };
//# sourceMappingURL=native-ByXg-_oZ.js.map
